import Vue from 'vue';

const store = {
    namespaced: true,
    state() {
        return {
            cart: {
                products: [],
                deliveryPrice: null,
                discount: 0,
                orderNumber: null,
                paymentUrl: null,
                trans_id: null,
                storeId: null,
                deliveryDateAndTime: null,
                taxPrice: null,
            },
            promoCode: null,
            promoCodeErrors: null,
            isFetchingPromoCode: false,
            deliveryText: '',
            showCheckoutModal: false,
            showPaymentModalSuccess: false,
            isCartOpen: false,
            showBulkOrderModal: false,
            continueAsGuest: false, // <--- добавлено
        };
    },
    getters: {
        getCart(state) {
            return state.cart;
        },
        getNotAvailableItems(state) {
            return (
                state.cart.products?.filter(item => item?.product?.active === false || item?.product?.available === false) || []
            );
        },
        deliveryText(state) {
            return state.deliveryText;
        },
        getProducts(state) {
            return state.cart.products;
        },
        getProductsLength(state) {
            let totalProducts = 0;
            state.cart.products.filter(p => {
                totalProducts += p.count;
            });

            if (!Number.isInteger(totalProducts)) {
                return totalProducts.toFixed(3); // Применяем toFixed только если число с точкой
            }
            return totalProducts; // Если целое, возвращаем как есть

            // return totalProducts;
        },
        getTotalPrice(state) {
            let newTotalPrice = 0;

            if (state.cart?.products?.length) {
                newTotalPrice = state.cart.products.reduce((accumulator, current) => {
                    const price = parseFloat(current?.product?.price);
                    const count = current?.count;

                    if (price != null && count != null) {
                        return accumulator + price * count;
                    }

                    return accumulator;
                }, 0);
            }

            // const promoCodePrice = parseFloat(state?.promoCode?.discount_sum);
            // console.log(promoCodePrice, 'promoCodePrice');
            // console.log(parseFloat(state?.promoCode?.discount_sum), ' 123 promoCodePrice');

            return Number(newTotalPrice.toFixed(2));
        },
        getTotalPriceWidthDiscount(state) {
            return state.promoCode?.general_price ? Number(Number(state.promoCode.general_price).toFixed(2)) : 0;
        },
        getTotalLoyaltiesGivePoints(state) {
            if (state.cart.products.length) {
                return state.cart.products.reduce((accumulator, current) => {
                    if (current.product.loyalty_checked) {
                        return accumulator;
                    }
                    return accumulator + Number(current.product.loyalty_give) * current.count;
                }, 0);
            }
            return 0;
        },
        getDeliveryPrice(state, getters, rootState, rootGetters) {
            let deliveryPrice = rootGetters['global/getDeliveryPrice'];

            if (!deliveryPrice.length) return 0;

            let totalPrice = rootGetters['cart/getTotalPrice'];
            const globalSettings = rootGetters['global/globalSettings'];
            const freeDeliveryPrice =
                getters.getSelectedRegionId === 3
                    ? globalSettings?.delivery_price[0]?.free_delivery
                    : globalSettings?.delivery_price[0]?.free_delivery_region || null;
            const conditionFreeDeivery = freeDeliveryPrice && totalPrice >= freeDeliveryPrice;

            //get max delivery price
            if (state.cart.deliveryMethod === 'pickup' || conditionFreeDeivery) {
                return 0;
            }

            if (state.cart.products.length) {
                let result = deliveryPrice.map(price => {
                    return getters.getSelectedRegionId === 3
                        ? price[getters.getSelectedDeliveryType + 'Kishinev']
                        : price.regionPrice;
                });
                return Math.max.apply(null, result);
            }
            return 0;
        },
        getDeliveryMethod(state) {
            return state.cart.deliveryMethod;
        },
        getCartFinalPrice(state, getters) {
            let handledDeliveryPrice = getters.getDeliveryPrice;
            const cartDeliveryPrice = state.cart.deliveryPrice;
            const totalPrice = getters.getTotalPriceWidthDiscount ? getters.getTotalPriceWidthDiscount : getters.getTotalPrice;

            if (cartDeliveryPrice !== null) handledDeliveryPrice = state.cart.deliveryPrice;

            return Number(totalPrice) + handledDeliveryPrice - state.cart.discount;
        },
        getToggleCart(state) {
            return state.toggle;
        },
        getShowCheckoutModal(state) {
            return state.showCheckoutModal;
        },
        getShowCheckoutModalSuccess(state) {
            return state.showCheckoutModalSuccess;
        },
        getShowFirstToKnowModalSuccess(state) {
            return state.firstToKnowModalSuccess;
        },
        getShowPreorderModalSuccess(state) {
            return state.showPreorderModalSuccess;
        },
        getShowOneClickModalSuccess(state) {
            return state.showOneClickModalSuccess;
        },
        getShowPaymentModalSuccess(state) {
            return state.showPaymentModalSuccess;
        },
        getRegions(state) {
            return state.addresses.regions;
        },

        getSelectedLocalityId(state) {
            return state.addresses.selectedLocalityId;
        },
        getDeliveryTypes(state) {
            return state.cart.deliveryTypes;
        },
        getSelectedDeliveryType(state) {
            return state.cart.selectedDeliveryType;
        },
        getOrderNumber(state) {
            return state.cart.orderNumber;
        },
        getStoreId(state) {
            return state.cart.storeId;
        },
        getDeliveryDateAndTime(state) {
            return state.cart.deliveryDateAndTime;
        },
        getPromoCode(state) {
            return state.promoCode;
        },
        getPromoCodeErrors(state) {
            return state.promoCodeErrors;
        },
        getIsFetchingPromoCode(state) {
            return state.cart.isFetchingPromoCode;
        },
        getTaxPrice(state) {
            return state.cart.taxPrice;
        },
        getIsCartOpen(state) {
            return state.isCartOpen;
        },
        getContinueAsGuest(state) {
            return state.continueAsGuest;
        },
        getShowBulkOrderModal(state) {
            return state.showBulkOrderModal;
        },
    },
    mutations: {
        setProducts(state, value) {
            state.cart.products = value;
        },
        setCountItemsForProduct: function (state, { productId, count, multiplicity }) {
            this.commit('cart/SET_PROMO_CODE', null);
            const fixedCount = Number(count.toFixed(3));
            if (fixedCount >= 0) {
                let newProduct = state.cart.products.find(e => parseFloat(e.product.productId) === parseFloat(productId));
                if (fixedCount < multiplicity) {
                    newProduct.count = multiplicity;
                } else {
                    newProduct.count = fixedCount;
                }
            }
            if (fixedCount === 0) {
                this.commit('cart/removeProductFromCart', productId);
            }
        },
        setUncheckedAllProductValues(state) {
            state.cart.products.forEach(product => {
                product.product.prescription_checked = false;
                product.product.loyalty_checked = false;
            });
        },
        setPrescription(state, { productId, prescription }) {
            let newProduct = state.cart.products.find(e => e.product.productId === productId);
            newProduct.product.prescription_checked = prescription;
        },
        setLoyalty(state, { productId, loyalty }) {
            let newProduct = state.cart.products.find(e => e.product.productId === productId);
            newProduct.product.loyalty_checked = loyalty;
        },
        removeProductFromCart(state, productId) {
            let newProductsList = state.cart.products.filter(e => Number(e.product.productId) !== Number(productId));
            Vue.set(state.cart, 'products', newProductsList);
        },
        SET_IS_SHOW_ADDED_TO_CART_NOTIFICATION(state, value) {
            state.toggle.isShowAddedToCartNotification = value;
        },
        setAddProductToCart(state, product) {
            let existingProduct = state.cart.products.find(
                e => parseFloat(e?.product?.productId) === parseFloat(product?.productId)
            );
            if (existingProduct) {
                if (existingProduct.count === 99999) {
                    existingProduct.count = 99999;
                } else {
                    existingProduct.count += product.multiplicity;
                }
            } else {
                state.cart.products.push({ product, count: product.multiplicity });
            }
        },
        setShowCheckoutModal(state, value) {
            state.showCheckoutModal = value;
        },
        setShowCheckoutModalSuccess(state, value) {
            state.showCheckoutModalSuccess = value;
        },
        setShowFirstToKnowModalSuccess(state, value) {
            state.firstToKnowModalSuccess = value;
        },
        setShowPreorderModalSuccess(state, value) {
            state.showPreorderModalSuccess = value;
        },
        setShowOneClickModalSuccess(state, value) {
            state.showOneClickModalSuccess = value;
        },
        setShowPaymentModalSuccess(state, value) {
            state.showPaymentModalSuccess = value;
        },
        setSelectedRegionId(state, value) {
            state.addresses.selectedRegionId = value;
            // TEMPORARY - I DON'T UNDERSTAND WHY IT'S
            // if (value !== 3) {
            //     state.cart.selectedDeliveryType = 'standart';
            // }
        },
        setSelectedLocalityId(state, value) {
            state.addresses.selectedLocalityId = value;
        },
        setDeliveryType(state, deliveryType) {
            state.cart.selectedDeliveryType = deliveryType;
        },
        SET_DELIVERY_METHOD(state, value) {
            state.cart.deliveryMethod = value;
        },
        emptyCart(state) {
            Vue.set(state.cart, 'products', []);
        },
        initCartStore(state, cart) {
            Vue.set(state.cart, 'products', cart.products || []);
        },
        setOrderNumber(state, value) {
            state.cart.orderNumber = value;
        },
        setPaymentUrl(state, value) {
            state.cart.paymentUrl = value;
        },
        setTransId(state, value) {
            state.cart.trans_id = value;
        },
        SET_DELIVERY_TEXT(state, value) {
            state.deliveryText = value;
        },
        SET_STORE_ID(state, value) {
            state.cart.storeId = value;
        },
        SET_CART_DELIVERY_PRICE(state, value) {
            state.cart.deliveryPrice = value;
        },
        SET_PROMO_CODE(state, value) {
            state.promoCode = value;
        },
        SET_PROMO_CODE_ERRORS(state, value) {
            state.promoCodeErrors = value;
        },
        SET_IS_FETCHING_PROMO_CODE(state, value) {
            state.isFetchingPromoCode = value;
        },
        SET_TAX_PRICE(state, value) {
            state.cart.taxPrice = value;
        },
        SET_IS_CART_OPEN(state, value) {
            state.isCartOpen = value;
        },
        SET_CONTINUE_AS_GUEST(state, value) {
            state.continueAsGuest = value;
        },
        SET_SHOW_BULK_ORDER_MODAL(state, value) {
            state.showBulkOrderModal = value;
        },
    },
    actions: {
        emptyCart({ commit }) {
            // Очищаем корзину
            commit('emptyCart');
        },
        setCount(context, data) {
            context.commit('setCountItemsForProduct', data);
        },
        removeProduct({ commit, dispatch, rootGetters, state }, productId) {
            const { product } = state?.cart?.products?.find(item => Number(item?.product?.productId) === Number(productId));

            commit('removeProductFromCart', Number(productId));

            const globalSettings = rootGetters['global/globalSettings'];

            const currency = globalSettings?.project_currency?.toUpperCase() || '';
            const sendData = {
                currency: currency,
                value: Number(product?.price),
                items: [
                    {
                        item_id: product?.productId,
                        item_name: product?.title,
                        discount: product?.discount || 0,
                        item_brand: product?.brand?.name || '',
                        item_category: product?.category?.[0]?.subcategoryTitle || '',
                        item_category2: product?.category?.[1]?.subcategoryTitle || '',
                        item_category3: product?.category?.[2]?.subcategoryTitle || '',
                        item_category4: product?.category?.[3]?.subcategoryTitle || '',
                        item_category5: product?.category?.[4]?.subcategoryTitle || '',
                        price: product?.discount ? Number(product?.old_price) : Number(product?.price),
                        quantity: 1,
                    },
                ],
            };

            dispatch('google_events/sendItemDeleteFromCartEvent', sendData, { root: true });
        },
        updateProducts(context, products) {
            context.commit('setProducts', products);
        },
        setCartDeliveryPrice(context, value) {
            context.commit('SET_CART_DELIVERY_PRICE', value);
        },
        setDeliveryMethod(context, value) {
            context.commit('SET_DELIVERY_METHOD', value);
        },
        async getProductsStockStatus({ commit }, ids) {
            try {
                // Преобразуем массив ids в строку
                const queryString = ids.map(id => `productIds=${id}`).join('&');

                if (queryString.length === 0) return;

                // Отправляем GET-запрос с форматированной строкой параметров
                return await this.$axios.get(`/general/product_checkout_status/?${queryString}`);
            } catch (error) {
                return new Error(error);
            }
        },

        // /general/product_checkout_status/?productIds=12&productIds=17
        addProductToCart({ commit, dispatch, rootGetters }, product) {
            const globalSettings = rootGetters['global/globalSettings'];

            const currency = globalSettings?.project_currency?.toUpperCase() || '';
            const sendData = {
                currency: currency,
                value: Number(product?.price),
                items: [
                    {
                        item_id: product?.productId,
                        item_name: product?.title,
                        discount: product?.discount || 0,
                        item_brand: product?.brand?.name || '',
                        item_category: product?.category?.[0]?.subcategoryTitle || '',
                        item_category2: product?.category?.[1]?.subcategoryTitle || '',
                        item_category3: product?.category?.[2]?.subcategoryTitle || '',
                        item_category4: product?.category?.[3]?.subcategoryTitle || '',
                        item_category5: product?.category?.[4]?.subcategoryTitle || '',
                        price: product?.discount ? Number(product?.old_price) : Number(product?.price),
                        quantity: 1,
                    },
                ],
            };

            dispatch('google_events/sendItemAddToCartEvent', sendData, { root: true });

            commit('setAddProductToCart', product);
        },
        getDeliveryText: async function ({ commit }) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/mi/delivery_info_text`,
                });
                commit('SET_DELIVERY_TEXT', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        async fetchPromoCode({ commit }, { promoCode, products, paymentMethod }) {
            commit('SET_IS_FETCHING_PROMO_CODE', true);
            commit('SET_PROMO_CODE_ERRORS', null);
            try {
                const response = await this.$axios.$post('/general/order/preview-promo/', {
                    promo_code: promoCode,
                    products,
                    payment_type: paymentMethod,
                });
                response.promo_code = promoCode;

                commit('SET_PROMO_CODE', response);

                // return response.data;
            } catch (error) {
                const errorData = error?.response?.data;
                if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
                    const values = Object.values(errorData);
                    const arrayValue = values.find(v => Array.isArray(v));
                    if (arrayValue) {
                        commit('SET_PROMO_CODE_ERRORS', arrayValue);
                    } else {
                        commit(
                            'SET_PROMO_CODE_ERRORS',
                            values.filter(v => typeof v === 'string')
                        );
                    }
                } else if (typeof errorData === 'string' || Array.isArray(errorData)) {
                    commit('SET_PROMO_CODE_ERRORS', errorData);
                } else {
                    commit('SET_PROMO_CODE_ERRORS', e?.message || 'Unknown error');
                }
                // if (error?.response && error?.response?.data?.[0]) {
                //     commit('SET_PROMO_CODE_ERRORS', error?.response?.data?.[0]);
                // }
                return error;
            } finally {
                commit('SET_IS_FETCHING_PROMO_CODE', false);
            }
        },
        async updateCurrentProducts({ state, commit, dispatch, rootState, rootGetters }) {
            const cartProducts = state.cart.products;
            if (!cartProducts?.length) return;

            const productIds = cartProducts.map(item => Number(item?.product?.productId));
            if (!productIds.length) return;

            // Получаем продукты по id через $api
            const { data } = await this.$api.products.getProductsByIds(productIds.join(','));

            // Оптимизация поиска: создаём Map для быстрого доступа по productId
            const dataMap = new Map(data.map(prod => [Number(prod.productId), prod]));

            // Обновляем платежные системы
            // await dispatch('global/fetchPaymentSystems', null, { root: true });

            // Обновляем продукты в корзине
            const updatedProducts = cartProducts.map(item => {
                const prod = dataMap.get(Number(item.product?.productId));
                if (!prod) {
                    return {
                        ...item,
                        product: {
                            ...item.product,
                            active: false,
                        },
                    };
                }
                return {
                    ...item,
                    product: {
                        ...prod,
                        active: !!prod?.available,
                    },
                };
            });

            commit('setProducts', updatedProducts);

            // // Проверка остатков (stockCheckHandler)
            // if (typeof this.$cartStockChecker === 'function') {
            //     // Если есть глобальный миксин/плагин
            //     await this.$cartStockChecker(JSON.parse(JSON.stringify(state.cart)));
            // } else if (rootGetters['cart/stockCheckHandler']) {
            //     // Если stockCheckHandler реализован как action/getter
            //     await dispatch('cart/stockCheckHandler', JSON.parse(JSON.stringify(state.cart)), { root: true });
            // }
        },
    },
};

export default store;
